function sea_get_hourly_price(facility_id, start_date, start_time, end_date, end_time, offset, promo_code) {

	$('.sea-find-parking-form-forms-overlay').addClass('sea-find-parking-form-forms-overlay-active');

	if (offset == 0) {

		var offsetISO8601 = '+00:00';

	} else {

		var offsetWIP = ((offset / 60) / 60) * 100;
		var offsetHours = offsetWIP.toString().slice(0, -2);
		var isNegative = offsetHours.indexOf('-');
		if (isNegative == 0) {
			if (offsetHours.length < 3) {
				offsetHours = offsetHours.substring(1);
				offsetHours = '-0' + offsetHours;
			}
		} else {
			if (offsetHours.length < 2) {
				offsetHours = '+0' + offsetHours;
			} else {
				offsetHours = '+' + offsetHours;
			}
		}
		var offsetMinutes = offsetWIP.toString().slice(-2);
		var offsetISO8601 = offsetHours + ':' + offsetMinutes;

	}

	offsetISO8601 = '+00:00';
	// console.log('offsetISO8601:', offsetISO8601);

	// convert dates and times to unix epoch format
	var start_date_time = new Date(start_date + 'T' + start_time + offsetISO8601).getTime() / 1000;
	var end_date_time = new Date(end_date + 'T' + end_time + offsetISO8601).getTime() / 1000;
	var now_date_time = GetUTCNow();

	// console.log('start_date_time:', start_date_time);
	// console.log('end_date_time:', end_date_time);
	// console.log('now_date_time:', now_date_time);

	$.ajax({
		type: 'post',
		url: '/wp-admin/admin-ajax.php',
		data: {
			action: 'calculate_hourly_price',
			facilityId: facility_id,
			startDateTime: start_date_time,
			endDateTime: end_date_time,
			nowDateTime: now_date_time,
			promoCode: promo_code
		},
		success: function (results) {
			var results = JSON.parse(results);
			console.log(results);
			if (results.status === 'success') {
				console.log('hello!');
				$('#hourly-price').val(results.new_price);
				$('#hourly-display-price').text(results.new_display_price);
				$('#sea-find-parking-form-hourly .form-card-message').empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
				// update button url!
				var submit_button = $('#hourly-submit');
				var checkout_url = new URL($(submit_button).attr('href'));
				checkout_url.searchParams.set('startTime', results.startDateTime);
				checkout_url.searchParams.set('endTime', results.endDateTime);
				$(submit_button).attr('href', checkout_url.toString());
			} else if (results.status === 'error') {
				$('#sea-find-parking-form-hourly .form-card-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
			}
			$('.sea-find-parking-form-forms-overlay').removeClass('sea-find-parking-form-forms-overlay-active');
		},
		error: function (results) {
			var results = JSON.parse(results);
			console.log(results);
			$('#sea-find-parking-form-hourly .form-card-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
			$('.sea-find-parking-form-forms-overlay').removeClass('sea-find-parking-form-forms-overlay-active');
		}
	});
}

function sea_get_product_price(facility_id, parking_type, promo_code) {
	$.ajax({
		type: 'post',
		url: '/wp-admin/admin-ajax.php',
		data: {
			action: 'calculate_product_price',
			facilityId: facility_id,
			parkingType: parking_type,
			promoCode: promo_code
		},
		success: function (results) {
			var results = JSON.parse(results);
			console.log(results);
			if (results.status === 'success') {
				if (parking_type === 'monthly') {
					$('#sea-find-parking-form-monthly .radio-buttons-group').empty().append(results.productTemplate);
					$('#sea-find-parking-form-monthly .form-card-message').empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
					sea_calculate_monthly_price();
				} else if (parking_type === 'coupon') {
					$('#sea-find-parking-form-coupon .radio-buttons-group').empty().append(results.productTemplate);
					$('#sea-find-parking-form-coupon .form-card-message').empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
					sea_calculate_coupon_price();
				}
			}
		},
		error: function(results) {
			var results = JSON.parse(results);
			console.log(results);
			if (parking_type === 'monthly') {
				$('#sea-find-parking-form-monthly .form-card-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
				sea_calculate_monthly_price();
			} else if (parking_type === 'coupon') {
				$('#sea-find-parking-form-coupon .form-card-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
				sea_calculate_coupon_price();
			}
		}
	});
}

function sea_calculate_monthly_price() {
  var quantity = $('#monthly-quantity').val();
  if (quantity > 0) {
		var product_id = $('input[name="monthly-options"]:checked').val();
    var product_price = $('input[name="monthly-options"]:checked').attr('data-price');
    var display_price = product_price * quantity;
    $('#monthly-display-price').text(USDollar.format(display_price).replace('$', '').trim());
    var stripe_price = product_price * 100;
    $('#monthly-price').val(stripe_price);
		// update button url!
		var submit_button = $('#monthly-submit');
		var checkout_url = new URL($(submit_button).attr('href'));
		checkout_url.searchParams.set('quantity', quantity);
		checkout_url.searchParams.set('productId', product_id);
		$(submit_button).attr('href', checkout_url.toString());
  } else {
    console.log('quantity is less than 1');
  }
}

function sea_calculate_coupon_price() {
  var quantity = $('#coupon-quantity').val();
  if (quantity > 0) {
		var product_id = $('input[name="coupon-options"]:checked').val();
    var product_price = $('input[name="coupon-options"]:checked').attr('data-price');
    var display_price = product_price * quantity;
    $('#coupon-display-price').text(USDollar.format(display_price).replace('$', '').trim());
    var stripe_price = product_price * 100;
    $('#coupon-price').val(stripe_price);
		// update button url!
		var submit_button = $('#coupon-submit');
		var checkout_url = new URL($(submit_button).attr('href'));
		checkout_url.searchParams.set('quantity', quantity);
		checkout_url.searchParams.set('productId', product_id);
		$(submit_button).attr('href', checkout_url.toString());
  } else {
    console.log('quantity is less than 1');
  }
}

$(document).ready(function() {

	// calculate hourly parking price
	var hourly_form = $('#sea-find-parking-form-hourly');
	if (hourly_form.length && $(hourly_form).hasClass('sea-find-parking-form-form-active')) {
		var facility_id = $('#facility_id').val();
		var start_date = $('#hourly-start-date').val();
		var start_time = $('#hourly-start-time').val();
		var end_date = $('#hourly-end-date').val();
		var end_time = $('#hourly-end-time').val();
		var offset = $('#offset').val();
		var promo_code = $('#hourly-promo-code').val();
		sea_get_hourly_price(facility_id, start_date, start_time, end_date, end_time, offset, promo_code);
	}

	$('#hourly-start-date, #hourly-start-time, #hourly-end-date, #hourly-end-time').on('change', function() {
		var facility_id = $('#facility_id').val();
		var start_date = $('#hourly-start-date').val();
		var start_time = $('#hourly-start-time').val();
		var end_date = $('#hourly-end-date').val();
		var end_time = $('#hourly-end-time').val();
		var offset = $('#offset').val();
		var promo_code = $('#hourly-promo-code').val();
		if (start_date > end_date) {
			$('#hourly-end-date').val(start_date);
			end_date = start_date;
		}
		sea_get_hourly_price(facility_id, start_date, start_time, end_date, end_time, offset, promo_code);
	});

	$('#hourly-promo-code').on('keyup', function() {
		setTimeout(function() {
			var facility_id = $('#facility_id').val();
			var start_date = $('#hourly-start-date').val();
			var start_time = $('#hourly-start-time').val();
			var end_date = $('#hourly-end-date').val();
			var end_time = $('#hourly-end-time').val();
			var offset = $('#offset').val();
			var promo_code = $('#hourly-promo-code').val();
			sea_get_hourly_price(facility_id, start_date, start_time, end_date, end_time, offset, promo_code);
		}, 500);
	});

	$('#hourly-promo-code-submit').on('click', function(e) {
		e.preventDefault();
		var facility_id = $('#facility_id').val();
		var start_date = $('#hourly-start-date').val();
		var start_time = $('#hourly-start-time').val();
		var end_date = $('#hourly-end-date').val();
		var end_time = $('#hourly-end-time').val();
		var offset = $('#offset').val();
		var promo_code = $('#hourly-promo-code').val();
		sea_get_hourly_price(facility_id, start_date, start_time, end_date, end_time, offset, promo_code);
	});

	$('#monthly-promo-code').on('keyup', function() {
		setTimeout(function() {
			var facility_id = $('#facility_id').val();
			var parking_type = 'monthly';
			var promo_code = $('#monthly-promo-code').val();
			sea_get_product_price(facility_id, parking_type, promo_code);
		}, 500);
	});

	$('#monthly-promo-code-submit').on('click', function(e) {
		e.preventDefault();
		var facility_id = $('#facility_id').val();
		var parking_type = 'monthly';
		var promo_code = $('#monthly-promo-code').val();
		sea_get_product_price(facility_id, parking_type, promo_code);
	});

	// update price for old monthly parking products
	$('input[name="monthly-options"], #monthly-quantity').on('change', function() {
		sea_calculate_monthly_price();
	});

	$('#coupon-promo-code').on('keyup', function() {
		setTimeout(function() {
			var facility_id = $('#facility_id').val();
			var parking_type = 'coupon';
			var promo_code = $('#coupon-promo-code').val();
			sea_get_product_price(facility_id, parking_type, promo_code);
		}, 500);
	});

	$('#coupon-promo-code-submit').on('click', function(e) {
		e.preventDefault();
		var facility_id = $('#facility_id').val();
		var parking_type = 'coupon';
		var promo_code = $('#coupon-promo-code').val();
		sea_get_product_price(facility_id, parking_type, promo_code);
	});

	// update price for coupon parking products
	$('input[name="coupon-options"], #coupon-quantity').on('change', function() {
		sea_calculate_coupon_price();
	});

	if ($('#sea-facility-location-map').length) {
		var map = $('#sea-facility-location-map');
		var lat = $(map).attr('data-latitude');
		var lng = $(map).attr('data-longitude');
		simpleMap(lat, lng, 'sea-facility-location-map');
	}

	// find parking form tabs
	$('.sea-find-parking-form-button').on('click', function() {
		var href = $(this).attr('href');
		if (href === undefined) {
			var form = $(this).attr('data-form');
			console.log(form);
			if (form === 'sea-find-parking-form-hourly') {
				var facility_id = $('#facility_id').val();
				var start_date = $('#hourly-start-date').val();
				var start_time = $('#hourly-start-time').val();
				var end_date = $('#hourly-end-date').val();
				var end_time = $('#hourly-end-time').val();
				var offset = $('#offset').val();
				var promo_code = $('#hourly-promo-code').val();
				sea_get_hourly_price(facility_id, start_date, start_time, end_date, end_time, offset, promo_code);
			}
			$('.sea-find-parking-form-button').removeClass('sea-find-parking-form-button-active');
			$(this).addClass('sea-find-parking-form-button-active');
			$('.sea-find-parking-form-form').removeClass('sea-find-parking-form-form-active');
			$('#' + form).addClass('sea-find-parking-form-form-active');
		}
	});

	facilityPhotos();

});
